import { IdiomaVO } from './idiomaVO';

export class CatalogoVO {
    descripcion: string;
    idNombre: string;
    id: number;
    searchQuery: string;
    filterAllLanguages: boolean = false;
    idioma: IdiomaVO;
}